module.exports = __webpack_public_path__ + "static/img/bg-fr.f174a508.png";